import PropTypes from 'prop-types';
import React from 'react';
import * as R from 'ramda';

import SelectField from 'Shared/form/SelectField';
import useFetchDiagnosisQuery from '../../hooks/useFetchConditionQuery';

const propTypes = {
    therapyId: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }),
};

const defaultProps = {
    therapyId: '',
    onChange: () => {},
    value: null,
};

function Conditions({ onChange, therapyId, value }) {
    const { isLoading, data: conditions } = useFetchDiagnosisQuery(therapyId);

    return (
            <SelectField
                label="Condition"
                options={conditions}
                getOptionValue={R.prop('id')}
                getOptionLabel={R.prop('name')}
                fieldName="condition"
                isClearable
                onChange={onChange}
                isLoading={isLoading}
                value={value}
            />
    );
}
Conditions.propTypes = propTypes;
Conditions.defaultProps = defaultProps;

export default Conditions;
